'use client';

import { usePrivy, useWallets } from '@privy-io/react-auth';

/**
 * Custom hook to access Privy wallet functionality
 * Returns ready state, user info, and wallet connection methods
 */
export function usePrivyWallet() {
  const { ready, authenticated, user, login, logout } = usePrivy();
  const { wallets, ready: walletsReady } = useWallets();

  const connectWallet = async () => {
    if (!ready) {
      console.warn('Privy is not ready yet');
      return;
    }
    
    if (!authenticated) {
      await login();
    }
  };

  const disconnectWallet = async () => {
    if (authenticated) {
      await logout();
    }
  };

  // Get the primary wallet (embedded or external)
  const primaryWallet = wallets.find(wallet => wallet.walletClientType === 'privy') || wallets[0];

  return {
    ready: ready && walletsReady,
    authenticated,
    user,
    wallets,
    primaryWallet,
    connectWallet,
    disconnectWallet,
    login,
    logout,
  };
}

